import { Navigate } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) return (
    <div className="container p-2">
      <div className="row">
        <div className="col-auto" style={{ padding: "8px" }}>
          <div className="card">
            <div className="card-body">
              <h1>Loading...</h1>
            </div>
          </div>
        </div>
      </div>
    </div>
  );;

  if (!user) return <Navigate to="/login" />;

  return <>{children}</>;
}
